import { z } from 'zod'

export const novelSchema = z.object({
  id: z.string(),
  roomId: z.string().nullable(),
  workId: z.string(),
  charName: z.string(),
  title: z.string(),
  length: z.enum(['short', 'medium', 'long']),
  tone: z.enum(['happy', 'sad', 'open', 'auto']),
  body: z.string(),
  cover: z.string(),
  chars: z.number(),
  createdAt: z.string(),
})
export const novelSummarySchema = novelSchema.omit({ body: true })
export const novelListSchema = z.object({ novels: z.array(novelSummarySchema) })
export type Novel = z.infer<typeof novelSchema>
export type NovelSummary = z.infer<typeof novelSummarySchema>
export type NovelList = z.infer<typeof novelListSchema>
